import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './Inquiries.module.css';
import Eyebrow from '../ui/Eyebrow';

export default function Inquiries() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <section className={styles.inquiries} id="inquiries" ref={ref}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 16 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <Eyebrow>INQUIRIES</Eyebrow>
        <h2 className={styles.heading}>Inquiries</h2>
        <div className={styles.emails}>
          <p className={styles.emailLine}>
            For investment opportunities, contact{' '}
            <a href="mailto:investor@infundra.com" className={styles.emailLink}>investor@infundra.com</a>
          </p>
          <p className={styles.emailLine}>
            To learn more about building your business on the Infundra platform, contact{' '}
            <a href="mailto:founders@infundra.com" className={styles.emailLink}>founders@infundra.com</a>
          </p>
        </div>
      </motion.div>
    </section>
  );
}
